import Avatar from 'react-avatar';
import './BrandingHeader.scss';
import { useSelector } from 'react-redux';

function BrandingHeader({ companyName, companyProfileImage }) {
    const userProfileData = useSelector(
        (state) => state?.GetUserProfileDataReducer?.UserProfileData
    );

    return (
        <div className="brandingHeader">
            <div className="brandingHeader__title">
                {companyName || userProfileData?.user?.usr_company_name}
            </div>
            <Avatar
                name={companyName || userProfileData?.user?.usr_company_name}
                src={companyProfileImage || userProfileData?.user?.image_url}
                size="60"
                color="#EEEFF3"
                maxInitials={2}
                fgColor="#000"
                round={true}
            />
        </div>
    );
}
export default BrandingHeader;
